var hamburger = require("./hamburger");
var sideNav = require("./sideNav");
var conditionGraphic = require("./conditionGraphic");
var conditionChangeGraphic = require("./conditionChangeGraphic");
var riskGraphic = require("./riskGraphic");
var definitionToggle = require("./definitionToggle");
var openlinks = require("./openlinks.js");
var global_vars = require("./global_var");
var wrapped_images = require("./wrap_images");
var utilities = require("./lib/utilities.js");
var surveys = require("./survey_dict.js");

